import React, { useContext } from "react";
import {
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import DiscountContext from "../../../../context/discounts/DiscountContext";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
}));

const DeleteDiscount = ({ openDeleteState }) => {
  const classes = useStyles();
  const [openDelete, setOpenDelete] = openDeleteState;

  const { selected_discount, deleteDiscount } = useContext(DiscountContext);

  const onClose = () => setOpenDelete(false);

  const onDelete = () => {
    deleteDiscount();
    onClose();
  };

  return (
    <Dialog
      disableBackdropClick
      fullWidth
      maxWidth="xs"
      open={openDelete}
      onClose={onClose}
    >
      <DialogTitle> Delete Discount </DialogTitle>
      <DialogContent dividers>
        <Typography>
          Are you sure to delete this discount({" "}
          <strong> {selected_discount.discount_name} </strong>) ?{" "}
        </Typography>{" "}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={onDelete}
        >
          Yes{" "}
        </Button>{" "}
        <Button
          variant="contained"
          color="secondary"
          className={classes.button}
          onClick={onClose}
        >
          No{" "}
        </Button>{" "}
      </DialogActions>{" "}
    </Dialog>
  );
};

export default DeleteDiscount;
